module.exports = __webpack_public_path__ + "static/img/bg-tr.f5abf33b.webp";